<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-card-title class="background">
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-card-text>
          <v-text-field
            outlined
            v-model="customField.name"
            label="Name"
            :rules="[$rules.required]"
            maxlength="250"
          >
          </v-text-field>
          <v-select
            v-model="customField.typeId"
            label="Type"
            :items="types"
            item-text="name"
            item-value="id"
            outlined
            :rules="[$rules.required]"
            required
          >
          </v-select>
          <v-select
            label="Is Required?"
            v-model="customField.isRequired"
            :items="yesNoItems"
            item-text="name"
            item-value="id"
            outlined
          >
          </v-select>
          <v-select
            label="Include In Reporting"
            v-model="customField.includeInReporting"
            :items="yesNoItems"
            item-text="name"
            item-value="id"
            outlined
          >
          </v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="py-2">
          <v-row dense>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn :loading="saving" @click="save">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "EditCustomFieldDialog",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    customField: {},
    yesNoItems: [
      { id: true, name: "Yes" },
      { id: false, name: "No" }
    ]
  }),
  watch: {},
  computed: {
    title() {
      return this.customField.id ? "Edit custom field" : "Add custom field";
    },
    ...mapGetters({ types: "lookup/custom_field_types" })
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("company/saveCustomField", this.customField)
          .then(() => {
            this.$emit("save", this.customField);
            this.$root.$snackbarSuccess("Custom field saved");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving"
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    showDialog(customField) {
      this.dialog = true;
      this.customField = Object.assign({ isRequired: false }, customField);
    }
  }
};
</script>
